
import { defineComponent } from "vue";
import PlanContainerResultLoadingSchemeJournal from "@/components/journals/PlanContainerResultJournal/PlanContainerResultLoadingSchemeJournal.vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import { getPlanContainerResultLoadingScheme } from "@/api/planContainerResultLoadingSchemeApi";
import store from "@/store";

export default defineComponent({
  components: {
    PlanContainerResultLoadingSchemeJournal,
    DxLoadPanel,
  },
  props: {
    parentModel: { required: true },
    parentEditingConfig: { required: false, type: TableEditingConfig },
  },
  computed: {
    packages() {
      if (this.model.packages) {
        let groups = this.model.packages;
        let result = ``;
        groups.forEach((element: any) => {
          if (element.storagePlace != "") result += `${element.storagePlace}: `;
          result += `${element.packagesList
            .map((x: any) => this.highlightedPackages && this.highlightedPackages.includes(x.name) ? 
              `<b class="highlightedPackage">${x.name}</b> ${x.count} шт.` : 
              `<b>${x.name}</b> ${x.count} шт.`)
            .join("; ")}`;
          result += `<br>`;
        });
        return result;
      }
      return "";
    },
    orders() {
      if (this.model.orders)
        return `${this.model.orders.map((x: any) => x.number).join("; ")}`;
      return "";
    },
    loadingSchemeDomId() {
      return `loadingSchemeData_${this.parentModel.id}`;
    },
    loadedPackages() {
      return (store.state as any).loadedPackages.loadedPackages;
    },
  },
  watch: {
    loadedPackages(newVal) {
      if (newVal)
        this.highlightedPackages = newVal[this.model.scheme.id];
      else
        this.highlightedPackages = null;
      this.$forceUpdate();
    }
  },
  methods: {
    onContentReady(e: any) {
      if (!this.firstRowSelected && e.component.totalCount() > 0) {
        e.component.selectRowsByIndexes([0]);
        this.firstRowSelected = true;
      }
    },
    async onSelectionChanged(e: any) {
      if (e.selectedRowsData && e.selectedRowsData.length) {
        const rowData = e.selectedRowsData[0];
        try {
          this.loading = true;
          const { data } = await getPlanContainerResultLoadingScheme(
            1589,
            rowData.id,
            this.parentModel.id
          );

          this.model = data;
          
          let loadedPackages = (store.state as any).loadedPackages.loadedPackages;
          if (loadedPackages)
            this.highlightedPackages = loadedPackages[this.model.scheme.id];
          else
            this.highlightedPackages = null;
          this.$forceUpdate();

        } finally {
          this.loading = false;
        }
      }
    },
  },
  async mounted() {
    this.firstRowSelected = false;
    this.loadingPanelPosition = { of: `#${this.loadingSchemeDomId}` };
  },
  data() {
    return {
      highlightedPackages: null,
      model: {},
      firstRowSelected: false,
      loading: false,
      loadingPanelPosition: {},
    };
  },
});
